import { User, useUserCredentialsPutMutation, } from '@alluradirect/react';
import { useState } from 'react';
import * as Sentry from '@sentry/nextjs';
import { ResetPasswordFormikValues } from 'components/views/pages/forgot-password/initialValues';
import { FormikHelpers } from 'formik';

interface Args {
  navigateOnResetPasswordSuccess?: () => void;
}

export type UserForgotPasswordReturn = ReturnType<typeof useForgotPassword>;

export const useForgotPassword = ({ navigateOnResetPasswordSuccess }: Args = {}) => {
  // We want this to reset on page refresh for additional security
  const [verified, setVerified] = useState(false);
  const [user, setUser] = useState<null | User>(null);
  const updateCredentials = useUserCredentialsPutMutation();

  const onSubmitResetPassword = async (
    vals: ResetPasswordFormikValues,
    helpers: FormikHelpers<ResetPasswordFormikValues>,
  ) => {
    if (!user) {
      setVerified(false);
      helpers.setSubmitting(false);
      return;
    }

    try {
      await updateCredentials.mutateAsync({
        email: user.EMAIL,
        id: user.ID,
        password: vals.PASSWORD,
      });
      navigateOnResetPasswordSuccess && navigateOnResetPasswordSuccess();
    } catch (e) {
      Sentry.captureException(e);
      setVerified(false);
    } finally {
      helpers.setSubmitting(false);
    }
  };

  return {
    verified,
    setVerified,
    user,
    setUser,
    onSubmitResetPassword,
  };
};
